'use strict';

var React = require('react');
var TargetLine_styles = require('./TargetLine.styles.js');
var Typography = require('../../../../node_modules/@material-ui/core/esm/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var TargetLine = function TargetLine(_ref) {
  var value = _ref.value,
      label = _ref.label;
  var classes = TargetLine_styles.useStyles({
    value: value
  });
  return React__default["default"].createElement("div", {
    "aria-label": "Target line is showing ".concat(label, " at ").concat(value, "%"),
    className: classes.container
  }, React__default["default"].createElement(Typography["default"], {
    className: classes.label,
    component: "div",
    variant: "caption"
  }, label), React__default["default"].createElement("span", {
    className: classes.line
  }));
};

module.exports = TargetLine;
